var map = {
	"./1.png": 9600,
	"./10.png": 4078,
	"./11.png": 222,
	"./12.png": 3098,
	"./13.png": 8215,
	"./14.png": 7037,
	"./15.png": 8029,
	"./16.png": 6269,
	"./17.png": 4483,
	"./18.png": 2184,
	"./2.png": 9152,
	"./3.png": 6324,
	"./4.png": 2499,
	"./5.png": 8285,
	"./6.png": 3950,
	"./7.png": 49,
	"./8.png": 96,
	"./9.png": 4796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5605;